export const DOMAIN_MESSAGE_MARKER = '<!-- DOMAIN SETUP -->';
export const DEPLOYMENT_MARKER = '<!-- 8e3d6f9c2a7b -->';
export const FAILED_DEPLOYMENT_MARKER = '<!-- 4f7a2b9e3d5c -->';
export const NEW_FILES_MARKER = '<!-- NEW FILES ADDED -->';
